export default __webpack_public_path__ + "static/globe-3191db9540a51ed15acf7db7316b4e11.mp4";